<template>
	<div class="side" :class="[ position, { editing } ]">
		
		<template v-if="position === 'bottom' || (character && fight.status !== 'next-opponent')">
			<character :character="character" />
			<div class="board">
				<div class="card-slots">
					<div v-for="(s, i) in character.nb_slots" class="card-slot" :key="s">
						<div v-if="character.cards[i]"
							class="card-wrap"
							:class="{ fighting: fighting_card === character.cards[i] }"
							:key="character.cards[i].id"
							:id="'card-' + character.cards[i].id"
							v-hammer:tap="() => select_card(character.cards[i])"
						>
							<card :card="character.cards[i]" />
						</div>
					</div>
				</div>
				<div v-if="position === 'bottom' && character.cards.length === 0 && !editing" class="deck-hint" v-hammer:tap="() => toggle_deck()">
					<div class="text">Choose 4 cards from your collection to fight</div>
					<div class="button">Open your collection</div>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Character from '@/components/game/character'
import Card from '@/components/game/card'
import Sounds from '@/js/sounds'

export default {
	name: 'side',
	data() {
		return {
			animation: false
		}
	},
	props: {
		position: { default: null },
		character: { default: null },
		editing: { default: false },
	},
	computed: {
		...mapGetters([ 'fight' ]),
		fighting_card() {
			if (this.character) return this.fight.round[this.character.type + '_card']
			return null
		}
	},
	watch: {
		'character.life'(newValue, oldValue) {
			if (newValue < oldValue) {
				this.animation = 'hit'
				setTimeout(() => {
					this.animation = false
				}, 400)
			}
		},
		'fighting_card'(newCard, oldCard) {
			if (oldCard && (!newCard || oldCard.id !== newCard.id)) {
				let $old_card = this.$el.querySelector('#card-' + oldCard.id)
				$old_card.style.transform = ''
			}

			if (newCard && (!oldCard || oldCard.id !== newCard.id)) {
				let $new_card = this.$el.querySelector('#card-' + newCard.id)
				let rect = $new_card.getBoundingClientRect()
				let x = window.innerWidth / 2 - rect.left - rect.width / 2
				let y = window.innerHeight / 2 - rect.top - rect.height / 2
				if (this.position === 'top') y -= rect.height / 2 + 16
				if (this.position === 'bottom') y += rect.height / 2 + 16
				$new_card.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1.2)'
			}
		}
	},
	methods: {
		toggle_deck() {
			this.$emit('toggle')
		},
		select_card(card) {
			if (this.editing) {
				Sounds.play('button')
				this.$store.dispatch('select_card', { card })
			}
		}
	},
	components: { Card, Character }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.side
	height calc(50% - 136px)
	// height calc(50% - 80px)
	// height 50%
	width 100%
	padding 16px 0
	flex center center 
	// flex-direction column
	&.bottom
		box-shadow inset 0 2px light
		&.editing
			.board .card-slots .card-slot .card-wrap
				cursor pointer
		.character
			order 1
			margin 0 64px 0 0
		.board
			order 2
	
	.character
		margin 0 0 0 64px
		flex center center
		flex-direction column
		order 2
	.board
		order 1
		height card_height
		flex center center
		.card-slots
			height 100%
			width 100%
			flex center center
			.card-slot
				width card_width
				height card_height
				margin 0 8px
				background-color alpha(#000, 15%)
				border-radius 8px
				.card-wrap
					transition 0.25s easeOutQuart
					&.fighting
						transition 0.25s easeOutBack
						transform scale(1.2)
						z-index 2
		.deck-hint
			absolute 0
			flex center center
			flex-direction column
			white-space nowrap
			text-align center
			background-color alpha(dark, 75%)
			.text
				margin 0 0 8px 0
			.button
				height 40px
				padding 0 16px
				background-color light
				color dark
				line-height (@height + 2px)
				cursor pointer
				&:hover
					background-color darken(light, 10%)
				&:active
					background-color darken(light, 10%)
					transform translateY(2px)


@keyframes hit
	0%
		background-position 0 top
	100%
		background-position -(188px * 14) top


@media (max-height: 950px)
	.side
		height calc(50% - 80px)

@media (max-height: 850px)
	.side
		height 50%


</style>
